import { render } from "./LayoutDashboard.vue?vue&type=template&id=308100c8"
import script from "./LayoutDashboard.vue?vue&type=script&lang=js"
export * from "./LayoutDashboard.vue?vue&type=script&lang=js"

import "./LayoutDashboard.vue?vue&type=style&index=0&id=308100c8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__